










import { bookGoodsModelProvider } from '../model'
import { computed } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'

export default defineClassComponent(
  () =>
    class {
      // 商品数据
      bookGoodsModel = bookGoodsModelProvider.inject()

      // 秒杀信息
      seckillInfo = computed(() => this.bookGoodsModel.value.seckillInfo)
    },
)
